import { loadCldr, setCulture, L10n } from "@syncfusion/ej2-base";
import * as numberingSystems from "cldr-data/supplemental/numberingSystems.json";
import * as gregorian from "cldr-data/main/id/ca-gregorian.json";
import * as numbers from "cldr-data/main/id/numbers.json";
import * as timeZoneNames from "cldr-data/main/id/timeZoneNames.json";

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);

L10n.load({
  id: {
    numerictextbox: {
      incrementTitle: "Tambah nilai",
      decrementTitle: "Kurangi nilai",
    },
  },
});

setCulture("id");
